import { Body1, Overline } from '@components/Texts/Texts';
import tw, { styled } from 'twin.macro';

export const PageBody = styled.div`
  ${tw`relative flex-1 grid col-span-full`}
  ${tw`sm:grid-cols-4 sm:gap-x-2 sm:pb-12`}
  ${tw`md:grid-cols-8 md:gap-x-2 md:pb-15`}
  ${tw`lg:grid-cols-12 lg:gap-x-3 lg:pb-15`}
  ${tw`xl:grid-cols-12 xl:gap-x-3 xl:pb-15`}
`;

export const AboutTitle = styled(Overline)`
  ${tw`text-light-high mb-2`}
  ${tw`sm:col-span-full sm:text-start sm:mt-20`}
  ${tw`md:col-start-2 md:col-end-8 md:text-start md:mt-20`}
  ${tw`lg:col-span-full lg:text-center lg:mt-15`}
  ${tw`xl:col-span-full xl:text-center xl:mt-15`}
`;

export const AboutHeading = styled.p`
  ${tw`text-light-high mb-6`}
  ${tw`sm:col-span-full sm:text-start`}
  ${tw`md:col-start-2 md:col-end-8 md:text-start`}
  ${tw`lg:col-start-4 lg:col-end-10 lg:text-center`}
  ${tw`xl:col-start-4 xl:col-end-10 xl:text-center`}

  [dir='rtl'] & {
    ${tw`leading-snug`}
  }
`;

export const AboutText = styled(Body1)`
  ${tw`text-light-medium mb-4`}
  ${tw`sm:col-span-full`}
  ${tw`md:col-start-2 md:col-end-8`}
  ${tw`lg:col-start-5 lg:col-end-9`}
  ${tw`xl:col-start-5 xl:col-end-9`}
`;
